export default __webpack_public_path__ + "static/2019_12-acb11a0b0f17d7630107fac49b2e6ae4.png";